import React, { Component } from "react";
import Transporte from "../Resources/transporte.svg";
import Card from "../Card/Card";
import "./LineasColectivos.css";
import fav from "../Resources/logo-salidas.png";
import guia from "./guia-accesibilidad-en-colectivos.pdf";
import secuencia from "./secuencia-acciones.pdf";
import senalizacion from "./senalizacion-sectores.pdf";
import DownloadModal from "../DownloadModal/DownloadModal";

export class LineasColectivos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpenGuia: false,
            isModalOpenSecuencia: false,
            isModalOpenSenalizacion: false,
        };
    }

    handleDownloadGuia = (email) => {
        const element = document.createElement("a");
        element.href = guia;
        element.download = "Guia-accesibilidad-en-colectivos.pdf";
        element.click();
        console.log(`Correo registrado para Guía: ${email}`);
    };

    handleDownloadSecuencia = (email) => {
        const element = document.createElement("a");
        element.href = secuencia;
        element.download = "Secuencia-de-acciones.pdf";
        element.click();
        console.log(`Correo registrado para Secuencia: ${email}`);
    };

    handleDownloadSenalizacion = (email) => {
        const element = document.createElement("a");
        element.href = senalizacion;
        element.download = "Señalización-de-sectores.pdf";
        element.click();
        console.log(`Correo registrado para Señalización: ${email}`);
    };

    render() {
        return (
            <main class="container-fluid text-center mb-5">
                <div class="row d-flex align-items-center justify-content-center">
                    <a href="/">
                        <img src={fav} width={200} alt=""></img>
                    </a>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12">
                        <h3 class="title">Líneas de colectivos</h3>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12">
                        <div class="container-transporte d-flex align-items-center justify-content-center bg-container-transporte p-5">
                            <Card
                                svg={Transporte}
                                title={""}
                                width={"100"}
                                height={"100"}
                                maxWidth="1000"
                                animation={false}
                                pagination={false}>
                                <div class="card-body-transporte">
                                    <p>
                                        Esta iniciativa fue creada y liderada
                                        por <strong>Alejandro Garro</strong>,
                                        gerente de la línea 85, quien, en marzo
                                        de 2022, impulsó la implementación de
                                        pictogramas adaptados en los colectivos.
                                        Nos convocó para llevar a cabo la
                                        adaptación cognitiva. Para ello, desde{" "}
                                        <strong>Salidas Inclusivas</strong>,
                                        utilizando pictogramas de la{" "}
                                        <strong>
                                            ARASAAC (Centro Aragonés para la
                                            Comunicación Aumentativa y
                                            Alternativa)
                                        </strong>{" "}
                                        adaptados para Argentina, realizamos la
                                        señalización completa de los colectivos,
                                        las secuencias de anticipación dentro y
                                        fuera de las unidades, así como las
                                        guías necesarias para su correcta
                                        implementación.
                                    </p>
                                    <p>
                                        Lo que comenzó como un proyecto para la
                                        línea 85 se expandió, alcanzando a más
                                        de 5.300 unidades en distintas líneas de
                                        colectivos. Desde sus inicios, la
                                        organización{" "}
                                        <strong>TGD Padres TEA Quilmes</strong>{" "}
                                        se sumó a la iniciativa, aportando su
                                        experiencia y compromiso.
                                    </p>
                                    <p>
                                        Posteriormente, las empresas{" "}
                                        <strong>Todo BUS y Dotta</strong> se
                                        unieron al proyecto, contribuyendo a su
                                        expansión. Gracias a Todo BUS llegaron
                                        colectivos 0Km con señalización
                                        pictográfica adaptada a{" "}
                                        <strong>
                                            Neuquén, Salta, Santa Fé y Córdoba
                                        </strong>
                                        . La empresa{" "}
                                        <strong>Autobuses Santa Fe</strong> sumó
                                        la señalización a toda su flota. Como
                                        parte de este crecimiento, los
                                        municipios de{" "}
                                        <strong>
                                            Quilmes, Lanús y Avellaneda
                                        </strong>{" "}
                                        implementaron la señalética pictográfica
                                        adaptada en sus paradas, reforzando el
                                        compromiso con la accesibilidad y la
                                        inclusión.
                                    </p>
                                    <p>
                                        En 2025, el Gobierno de la Ciudad de
                                        Buenos Aires decretó la obligatoriedad
                                        de los pictogramas adaptados en todos
                                        los colectivos de la ciudad,
                                        garantizando accesibilidad cognitiva
                                        para personas neurodivergentes, adultos
                                        mayores, turistas y cualquier usuario
                                        que necesite una comunicación más clara
                                        (<strong>Resol-2025-33-GCBA</strong>).
                                    </p>
                                    <p>
                                        Este avance posicionó a Argentina como
                                        pionera en Latinoamérica en la
                                        implementación de señalización
                                        pictográfica en el transporte público,
                                        con el objetivo de facilitar la
                                        movilidad y promover la inclusión.
                                    </p>
                                    <p>
                                        Este proyecto demuestra cómo la
                                        colaboración y el compromiso pueden
                                        transformar el espacio público en un
                                        entorno más accesible e inclusivo para
                                        todos.
                                    </p>
                                    <p>
                                        <strong>
                                            ¡Sigamos avanzando juntos hacia una
                                            sociedad sin barreras!
                                        </strong>
                                    </p>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <button
                                            onClick={() => this.setState({ isModalOpenGuia: true })}
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Guía de accesibilidad en colectivos
                                        </button>
                                    </div>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <button
                                            onClick={() => this.setState({ isModalOpenSecuencia: true })}
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Secuencia de acciones
                                        </button>
                                    </div>
                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <button
                                            onClick={() => this.setState({ isModalOpenSenalizacion: true })}
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Señalización de sectores
                                        </button>
                                    </div>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <a
                                            href="https://www.instagram.com/labandadesaes/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(
                                                    "https://www.instagram.com/labandadesaes/",
                                                    "_blank"
                                                );
                                            }}>
                                            Instagram @labandadesaes
                                        </a>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>

                <DownloadModal
                    isOpen={this.state.isModalOpenGuia}
                    onClose={() => this.setState({ isModalOpenGuia: false })}
                    onDownload={this.handleDownloadGuia}
                />

                <DownloadModal
                    isOpen={this.state.isModalOpenSecuencia}
                    onClose={() => this.setState({ isModalOpenSecuencia: false })}
                    onDownload={this.handleDownloadSecuencia}
                />

                <DownloadModal
                    isOpen={this.state.isModalOpenSenalizacion}
                    onClose={() => this.setState({ isModalOpenSenalizacion: false })}
                    onDownload={this.handleDownloadSenalizacion}
                />
            </main>
        );
    }
}
